/**
 * AdminLoginWall — 断开态整屏品牌登录墙 (scope gate)。
 *
 * 设计依据: 设计稿 frag-adm-e #ae-login 批注①。
 *
 * 改前: 断开态照常渲染 sider + 12 项菜单 + 内容区, 每一页各自报"请先微信扫码登录",
 * 冷启动还不自动弹登录 —— 新用户看到的第一印象是"一个到处报错的空壳后台", 而登录入口
 * 只是顶栏右上角一个 size="small" 的小按钮。
 * 改后: scopeStatus 为 disconnected / error 时整屏就是登录墙, 左半品牌与边界, 右半一张
 * 登录卡答完"扫哪里 / 还剩多久 / 怎么核对是我"。Modal 只留给已登录后的"更换账号"。
 */

import { Alert } from 'antd';

import { AdminQrLoginPanel, useQrLogin } from './AdminQrLogin';
import type { AdminScopeStatus } from './AdminScopeContext';
import './AccountConnect.css';

export default function AdminLoginWall({
  status,
  errorText,
  onAuthenticated,
}: {
  status: AdminScopeStatus;
  errorText: string | null;
  onAuthenticated: () => void;
}) {
  const qr = useQrLogin({ enabled: true, onAuthenticated });

  return (
    <div className="admin-login-wall">
      <section className="admin-login-wall__brand">
        <span className="admin-login-wall__glow" aria-hidden="true" />
        <span className="admin-login-wall__mark" aria-hidden="true" />
        <h1 className="admin-login-wall__name">星火 Ember</h1>
        <p className="admin-login-wall__desc">餐饮门店经营中台 · 电脑端</p>
        <p className="admin-login-wall__value">
          经营、人事、审批与主数据，
          <br />
          一屏管好全部直营门店。
        </p>
        <p className="admin-login-wall__brands">尹三顺 · 俏江溪 内部系统，仅限授权账号使用</p>
      </section>

      <section className="admin-login-wall__panel">
        <div className="admin-login-wall__panel-inner">
          {status === 'error' && errorText ? (
            <Alert
              type="warning"
              showIcon
              className="admin-login-wall__alert"
              message="当前账号不可用"
              description={errorText}
            />
          ) : null}
          <AdminQrLoginPanel qr={qr} variant="wall" />
        </div>
      </section>
    </div>
  );
}
